"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resetGetMyTutorialsPromise = exports.resetGetMePromise = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

var profileKeys = _interopRequireWildcard(require("./profileKeys"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var minNameLength = 2;
var getMePromise;
var getMyTutorialsPromise;

var resetGetMePromise = function resetGetMePromise() {
  getMePromise = undefined;
};

exports.resetGetMePromise = resetGetMePromise;

var resetGetMyTutorialsPromise = function resetGetMyTutorialsPromise() {
  getMyTutorialsPromise = undefined;
};

exports.resetGetMyTutorialsPromise = resetGetMyTutorialsPromise;

var UserService = /*#__PURE__*/function () {
  function UserService() {
    _classCallCheck(this, UserService);
  }

  _createClass(UserService, null, [{
    key: "normalizeName",
    value: function normalizeName(displayName) {
      return displayName.toLowerCase().trim().replace(/[^\w\s-]|_/gi, '').replace(/\s+/g, '-');
    }
  }, {
    key: "getTenantUrl",
    value: function getTenantUrl(name) {
      return "https://".concat(UserService.normalizeName(name), ".").concat(typeof window !== 'undefined' ? env.REACT_APP_DOMAIN : '');
    }
  }, {
    key: "isAuth0UserIdValid",
    value: function isAuth0UserIdValid(auth0UserId) {
      return auth0UserId !== null && auth0UserId !== undefined;
    }
  }, {
    key: "isNameValid",
    value: function isNameValid(name) {
      return name !== undefined && name !== null && name.length >= minNameLength && !name.match(/^-|-$/);
    }
  }, {
    key: "isUpdateUserRequestValid",
    value: function isUpdateUserRequestValid(updateUserRequest) {
      if (updateUserRequest === null || updateUserRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        phone: _joiBrowser["default"].string().allow('').optional(),
        email: _joiBrowser["default"].string().email().required(),
        firstName: _joiBrowser["default"].string().allow('').optional(),
        lastName: _joiBrowser["default"].string().allow('').optional(),
        avatar: _joiBrowser["default"].string().allow(null).min(2).optional()
      });

      return _joiBrowser["default"].validate(updateUserRequest, schema).error === null;
    }
  }, {
    key: "isLocalStorageUserProfileValid",
    value: function isLocalStorageUserProfileValid() {
      var profileExpiration = global.window.localStorage.getItem('profile_expiration');

      if (profileExpiration === null) {
        return false;
      }

      var expirationTime = new Date(profileExpiration);
      var now = new Date();

      if (now > expirationTime) {
        return false;
      }

      return true;
    }
  }, {
    key: "setLocalProfileFromTenantApiResponse",
    value: function setLocalProfileFromTenantApiResponse(response) {
      var profile = UserService.getProfile();
      var userMetadata = response.user_metadata || {};
      profile[profileKeys.firstName] = userMetadata.first_name || '';
      profile[profileKeys.lastName] = userMetadata.last_name || '';
      profile[profileKeys.email] = userMetadata.email || '';
      profile[profileKeys.phone] = userMetadata.phone || '';
      profile[profileKeys.avatar] = userMetadata.avatar || '';
      profile[profileKeys.tenants] = response.app_metadata ? response.app_metadata.tenants : {}; // set for browser cache change of profile avatar, see UserMenu.js

      profile.updated_at = new Date().toDateString();
      global.window.localStorage.setItem('profile_expiration', new Date(new Date().getTime() + 30 * 60 * 1000));
      UserService.setProfile(profile);
      return profile;
    }
  }, {
    key: "getMe",
    value: function getMe() {
      var _this = this;

      if (!getMePromise) {
        getMePromise = new Promise(function (resolve, reject) {
          var localProfile = UserService.getProfile();

          if (!!localProfile.user_id && UserService.isLocalStorageUserProfileValid()) {
            resolve(localProfile);
          } else {
            UserService.httpService.get('/me').then(function (response) {
              UserService.setProfile(response);
              resolve(_this.setLocalProfileFromTenantApiResponse(response));
            }, function () {
              reject();
            });
          }
        });
      }

      return getMePromise;
    }
  }, {
    key: "searchUsers",
    value: function searchUsers(search) {
      /*
        when using the baseURL of /tenant-api/users and then only
        appending the query string of ?search= to that request
        axios is appening a / after users (users/search=...) which gives us a 403
      */
      return this.httpService.get("?search=".concat(search));
    }
  }, {
    key: "getMyTenants",
    value: function getMyTenants() {
      return this.httpService.get('/me/tenants');
    }
  }, {
    key: "leaveTenant",
    value: function leaveTenant(tenantName) {
      if (!UserService.isNameValid(tenantName)) {
        return Promise.reject(new Error('Organization Name invalid'));
      }

      global.window.localStorage.removeItem('profile_expiration');
      return this.httpService["delete"]("/me/tenants/".concat(tenantName));
    }
  }, {
    key: "updateUser",
    value: function updateUser(auth0UserId, updateUserRequest) {
      var _this2 = this;

      if (!UserService.isAuth0UserIdValid(auth0UserId)) {
        return Promise.reject(new Error('User ID missing'));
      }

      if (!UserService.isUpdateUserRequestValid(updateUserRequest)) {
        return Promise.reject(new Error('Invalid update user request'));
      }

      global.window.localStorage.removeItem('profile_expiration');
      return new Promise(function (resolve) {
        _this2.httpService.patch("/".concat(auth0UserId), updateUserRequest).then(function (response) {
          _this2.getMe();

          resolve(_this2.setLocalProfileFromTenantApiResponse(response));
        });
      });
    }
  }, {
    key: "userHasTenants",
    value: function userHasTenants() {
      var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : UserService.getProfile();
      return profile && profile.app_metadata && profile.app_metadata.tenants && Object.keys(profile.app_metadata.tenants).length > 0;
    }
  }, {
    key: "getProfile",
    value: function getProfile() {
      return global.window.localStorage.getItem('profile') ? JSON.parse(global.window.localStorage.getItem('profile')) : {};
    }
  }, {
    key: "getSubscribedTenants",
    value: function getSubscribedTenants(profile) {
      if (!UserService.userHasTenants(profile)) {
        return [];
      }

      return Object.keys(profile.app_metadata.tenants);
    }
  }, {
    key: "setProfile",
    value: function setProfile(userProfile) {
      var profile = userProfile;
      profile.subscribedTenants = UserService.getSubscribedTenants(profile);
      global.window.localStorage.setItem('profile', JSON.stringify(profile));
    }
  }, {
    key: "userHasRoleForTenant",
    value: function userHasRoleForTenant(roleNeeded, tenant, user) {
      if (user === undefined || user === null) {
        return false;
      }

      var userTenants = user[profileKeys.tenants];

      if (userTenants === undefined || userTenants === null) {
        return false;
      }

      var userTenant = userTenants[tenant];

      if (userTenant === undefined || userTenant === null) {
        return false;
      }

      var tenantRoles = userTenant.roles;

      if (tenantRoles === undefined || tenantRoles === null) {
        return false;
      }

      return tenantRoles.indexOf(roleNeeded) > -1;
    }
  }, {
    key: "getUserRolesForTenant",
    value: function getUserRolesForTenant(user, tenant) {
      if (user === undefined || user === null) {
        return [];
      }

      var userTenants = user[profileKeys.tenants];

      if (userTenants === undefined || userTenants === null) {
        return [];
      }

      var userTenant = userTenants[tenant];

      if (userTenant === undefined || userTenant === null) {
        return [];
      }

      var tenantRoles = userTenant.roles;

      if (tenantRoles === undefined || tenantRoles === null) {
        return [];
      }

      return userTenant.roles;
    }
  }, {
    key: "getMySeenTutorials",
    value: function getMySeenTutorials() {
      var _this3 = this;

      if (!getMyTutorialsPromise) {
        getMyTutorialsPromise = new Promise(function (resolve) {
          if (global.window.localStorage.getItem('user_tutorials')) {
            resolve(JSON.parse(global.window.localStorage.getItem('user_tutorials')));
          } else {
            _this3.httpService.get('/me/userTutorials').then(function (response) {
              global.window.localStorage.setItem('user_tutorials', JSON.stringify(response));
              resolve(response);
            });
          }
        });
      }

      return getMyTutorialsPromise;
    }
  }, {
    key: "updateMySeenTutorials",
    value: function updateMySeenTutorials(updatedSeenTutorials) {
      var _this4 = this;

      if (updatedSeenTutorials === null || updatedSeenTutorials === undefined) {
        return Promise.reject(new Error('Invalid update user seen tutorials request'));
      }

      return new Promise(function (resolve) {
        _this4.httpService.patch('/me/userTutorials', updatedSeenTutorials).then(function (response) {
          global.window.localStorage.setItem('user_tutorials', JSON.stringify(response));
          resolve(response);
        });
      });
    }
  }, {
    key: "clearLocalStorage",
    value: function clearLocalStorage() {
      global.window.localStorage.removeItem('profile');
      global.window.localStorage.removeItem('profile_expiration');
      global.window.localStorage.removeItem('user_tutorials');
    }
  }]);

  return UserService;
}();

exports["default"] = UserService;
UserService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_TENANT_API : '', "/users")
});